import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var getCodesFromLocale = function getCodesFromLocale(locale) {
  var match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
  if (!match) {
    throw Error('Unable to get language and country from invalid Locale');
  }
  var _match = _slicedToArray(match, 3),
    language = _match[1],
    country = _match[2];
  return {
    language: language.toLowerCase(),
    // when country code is missed, let it empty and we will use language/locale to find language file
    country: country ? country.toUpperCase() : ''
  };
};